module.exports = __webpack_public_path__ + "static/media/dark.1dd75bc3.png";